export default "__VITE_PUBLIC_ASSET__962d43f2__"